import { render } from "./LogoType.vue?vue&type=template&id=5a132a4f"
import script from "./LogoType.vue?vue&type=script&lang=js"
export * from "./LogoType.vue?vue&type=script&lang=js"

import "./LogoType.vue?vue&type=style&index=0&id=5a132a4f&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__